import React, { createContext, useState, useContext } from "react";
import styled from "styled-components";
import { ClimbingBoxLoader } from "react-spinners";

import { StyledLayout, Wrapper } from "../components/layout/layout";
import { Black, OffWhite } from "../components/theme/colors";
import { useLoadingManager } from "./LoadingManager";

const Body = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  margin: 0;
`;

const CenteredLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false); // Legacy loading state for backward compatibility
  const loadingManager = useLoadingManager();

  // Check if any critical loading is active
  const isCriticalLoading = loadingManager?.isCriticalLoading() || false;

  // Show loading spinner if legacy loading is true OR if critical loading is active
  const shouldShowLoader = loading || isCriticalLoading;

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {shouldShowLoader && (
        <Wrapper $background={Black}>
          <StyledLayout>
            <Body>
              <CenteredLoaderContainer>
                <ClimbingBoxLoader color={OffWhite} />
              </CenteredLoaderContainer>
            </Body>
          </StyledLayout>
        </Wrapper>
      )}
      {children}
    </LoadingContext.Provider>
  );
};

// Custom Hook to use the LoadingContext (legacy)
export const useLoading = () => useContext(LoadingContext);

// Enhanced hook that combines legacy and new loading manager
export const useEnhancedLoading = () => {
  const legacyLoading = useContext(LoadingContext);
  const loadingManager = useLoadingManager();

  return {
    // Legacy methods (backward compatibility)
    loading: legacyLoading.loading,
    setLoading: legacyLoading.setLoading,

    // New enhanced methods
    isLoading: (key) => loadingManager.isLoading(key),
    isCriticalLoading: () => loadingManager.isCriticalLoading(),
    getLoadingState: (key) => loadingManager.getLoadingState(key),
    getStats: () => loadingManager.getStats(),
    loadWithCache: loadingManager.loadWithCache,

    // Manager instance for advanced usage
    manager: loadingManager,
  };
};
